(function () {
  'use strict';

  // Gold-light enhancement only. Content remains visible without JS.
  var revealSelector = '.doc-light';

  var reducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver = null;
  var started = false;

  function scheduleAfterPaint(task) {
    var run = function () {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(task, { timeout: 1200 });
        return;
      }
      window.setTimeout(task, 0);
    };

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
      return;
    }

    window.setTimeout(run, 0);
  }

  function reveal(item) {
    if (item.getAttribute('data-documentary-revealed') === 'true') return;
    item.setAttribute('data-documentary-revealed', 'true');
    item.classList.add('is-visible');
  }

  function initializeReveals(scope) {
    var root = scope || document;
    var items = Array.prototype.slice.call(root.querySelectorAll(revealSelector)).filter(function (item) {
      return item.getAttribute('data-documentary-revealed') !== 'true';
    });
    if (!items.length) return;

    document.documentElement.classList.add('documentary-motion-ready');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(reveal);
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          revealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '48px 0px',
        threshold: 0.01
      });
    }

    items.forEach(function (item) {
      revealObserver.observe(item);
    });
  }

  function startMotion(options) {
    var settings = options || {};
    if (settings.force) {
      initializeReveals(document);
      return;
    }

    if (started) return;
    started = true;

    scheduleAfterPaint(function () {
      initializeReveals(document);
    });
  }

  function fadeAudio(audio, options) {
    if (!audio) return Promise.resolve(false);

    var settings = options || {};
    var duration = Math.max(0, Number(settings.duration) || 600);
    var target = Math.max(0, Math.min(1, Number(settings.to) || 0));
    var startVolume = audio.volume;

    if (reducedMotion || duration === 0 || startVolume === target) {
      audio.volume = target;
      return Promise.resolve(true);
    }

    return new Promise(function (resolve) {
      var startTime = 0;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        audio.volume = startVolume + ((target - startVolume) * eased);

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          resolve(true);
        }
      }

      window.requestAnimationFrame(step);
    });
  }

  window.BBJTDocumentaryMotion = {
    initialize: function (scope) {
      initializeReveals(scope || document);
    },
    fadeAudio: fadeAudio
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startMotion();
    }, { once: true });
  } else {
    startMotion();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      started = false;
      startMotion({ force: true });
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeReveals(event.target);
  });
})();
